import TenantSupportLink from "./TenantSupportLink";

export * from "./TenantPrivacyPolicyLink";
export * from "./TenantTermsAndConditionsLink";
export { TenantSupportLink };
